var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83398 19.4398L8.38209 18.9612C12.9912 14.9366 15.334 11.4225 15.334 8.3335C15.334 3.95905 11.9198 0.833496 7.83398 0.833496C3.74819 0.833496 0.333984 3.95905 0.333984 8.3335C0.333984 11.4225 2.67674 14.9366 7.28588 18.9612L7.83398 19.4398ZM7.83398 17.2193C3.92283 13.6944 2.00065 10.7075 2.00065 8.33313C2.00065 4.91363 4.63741 2.4998 7.83398 2.4998C11.0306 2.4998 13.6673 4.91363 13.6673 8.33313C13.6673 10.7075 11.7451 13.6944 7.83398 17.2193Z",
    fill: "#28A745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/new-icon.a59d268ee659063ffe2741a78234191c.svg";
export { ForwardRef as ReactComponent };